import {SCOPE_CHANGED} from '../../actions/generic/types';
import _ from 'lodash';

const INITIAL_STATE = {
    isDirty: false
}

export default (state = INITIAL_STATE, action) => {
    switch(action.type){
        case SCOPE_CHANGED:
            return {...state, isDirty: action.payload.isDirty};
        default:
            return state;
    }
}